module.exports = __webpack_public_path__ + "static/forecast/weather/nightheavyrain-5a8e35e0751d990f3059e1edd723811a.svg";